import React, { useState, useEffect } from "react";
import "./custombutton.css";

const CustomButton = (props) => {
  const [btnColorChange, setBtnColorChange] = useState("");

  useEffect(() => {
    if (props.from && props.from === "Noti") {
      if (props.text === "All Member") {
        setBtnColorChange("btn-memberTypes btn-allMembers");
      } else if (props.text === "Diamond") {
        setBtnColorChange("btn-memberTypes btn-Diamond");
      } else if (props.text === "Silver") {
        setBtnColorChange("btn-memberTypes btn-Silver");
      } else {
        setBtnColorChange("btn-memberTypes btn-Gold");
      }
    }
  }, [props]);

  return (
    <button
    className={btnColorChange + " " + (props.from !== "Noti" ? "button " : "") + (props.className ? props.className : "")}
    onClick={props.onClick}
    >
      {props.addIcon === true && (
        <img src={props.icon} className="icon" alt="icon" />
      )}
      {props.text}
    </button>
  );
};
export default CustomButton;
